// extracted by mini-css-extract-plugin
module.exports = {"separator":"SignupOrSeparator-module__separator___XFD27","text":"SignupOrSeparator-module__text___3yC8v"};